module.exports = __webpack_public_path__ + "static/media/kayrataka.cf8302c0.jpg";